import { isJSON } from '../utils/isJson';

export default {
  set(key: string, value: string) {
    localStorage.setItem(key, JSON.stringify(value));
  },
  get<T = string>(key: string): T | null {
    const value = localStorage.getItem(key);

    if (!value) {
      return null;
    }
    return isJSON(value) ? JSON.parse(value) : value;
  },
  has(key: string) {
    return localStorage.getItem(key) !== null;
  },
  remove(key: string) {
    localStorage.removeItem(key);
  },
  clear() {
    localStorage.clear();
  },
};
